import { RouteConfig } from "vue-router";

export const REmployerEmployeesTemplatePersonalInfo: RouteConfig = {
  path: "personal-info",
  component: () =>
    import(
      /* webpackChunkName: "employer-employees-template-personal-info" */
      "./VEmployerEmployeesTemplatePersonalInfo.vue"
    ),
  meta: {
    title: "Employees",
    label: "personal info",
    tabName: "employee_personal_info",
    alias: "personal_info",
  },
};
